/**
 *
 * SummaryView
 *
 */

// @flow

import { Cell, Grid, UnsafeHtml } from '@fil-global/eiswurfel';
import _isArray from 'lodash/isArray';
import type { Node } from 'react';
import React from 'react';

import type { Props } from './types';

const SummaryView = ({ description, notes }: Props): Node => (
  <Grid extraClasses="summary-view">
    <Cell extraClasses="main">{description}</Cell>

    {_isArray(notes) &&
      notes.map((note, i) => (
        <Cell extraClasses="note" key={i.toString()}>
          <UnsafeHtml>{note}</UnsafeHtml>
        </Cell>
      ))}
  </Grid>
);

SummaryView.defaultProps = {};

export default SummaryView;
